import React from 'react'
import { makeStyles } from "@mui/styles";

const styles = makeStyles({
    button:{
        backgroundColor:"#626B7E",
        color:"white",
        fontSize:"14px",
        padding:"0.4rem 1rem",
        border:"none",
        borderRadius:"4px",
        cursor:"pointer"

    }
})

const ResetBtn = ({ message }) => {

    const classes = styles();
    return <button className={ classes.button }  >
        { message }
    </button>
}

export default ResetBtn;